import { format } from 'date-fns';
import { FC } from 'react';
import { CaptionProps, useNavigation } from 'react-day-picker';
import { Row, Text } from '~/commonComponents';
import { Icon } from '~/commonComponents/Icon';
import { Colors } from '~/themes/colors';

const ARROW_BUTTON_SIZE = 38;
const ARROW_BORDER_RADIUS = 6;

const ACTIVE_BOX_SHADOW = '0px 1px 2px rgba(0,0,0,0.15), 0px 3px 10px 1px rgba(0,0,0,0.15)';
const HOVER_BOX_SHADOW = '0px 2px 4px rgba(0,0,0,0.2), 0px 4px 14px 2px rgba(0,0,0,0.2)';

export const MonthNavigation: FC<CaptionProps> = ({ displayMonth, displayIndex }) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();

  const isPrevDisabled = !previousMonth;
  const showPrev = displayIndex === 0;
  const showNext = displayIndex === 1;

  return (
    <Row alignItems="center" gap={10}>
      {showPrev && (
        <button
          type="button"
          data-testid="month-nav-prev"
          data-cy="month-nav-prev"
          disabled={isPrevDisabled}
          onClick={() => previousMonth && goToMonth(previousMonth)}
          style={{
            all: 'unset',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: ARROW_BUTTON_SIZE,
            height: ARROW_BUTTON_SIZE,
            borderRadius: ARROW_BORDER_RADIUS,
            backgroundColor: isPrevDisabled ? Colors.secondary_200 : Colors.secondary_500,
            boxShadow: isPrevDisabled ? 'none' : ACTIVE_BOX_SHADOW,
            cursor: isPrevDisabled ? 'default' : 'pointer',
            pointerEvents: isPrevDisabled ? 'none' : 'auto',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={(e) => {
            if (!isPrevDisabled) {
              e.currentTarget.style.transform = 'scale(1.1)';
              e.currentTarget.style.backgroundColor = Colors.secondary_350;
              e.currentTarget.style.boxShadow = HOVER_BOX_SHADOW;
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.backgroundColor = isPrevDisabled
              ? Colors.secondary_200
              : Colors.secondary_500;
            e.currentTarget.style.boxShadow = isPrevDisabled ? 'none' : ACTIVE_BOX_SHADOW;
          }}
        >
          <Icon name="chevron-left" color={Colors.white} />
        </button>
      )}

      <Text
        data-testid="month-nav-label"
        data-cy="month-nav-label"
        bold
        fontSize={22}
        textAlign="center"
        flex={1}
        backgroundColor={Colors.secondary_50}
        borderRadius={6}
        padding="4px 12px"
      >
        {format(displayMonth, 'MMMM')}
      </Text>

      {showNext && (
        <button
          type="button"
          data-testid="month-nav-next"
          data-cy="month-nav-next"
          disabled={!nextMonth}
          onClick={() => nextMonth && goToMonth(nextMonth)}
          style={{
            all: 'unset',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: ARROW_BUTTON_SIZE,
            height: ARROW_BUTTON_SIZE,
            borderRadius: ARROW_BORDER_RADIUS,
            backgroundColor: Colors.secondary_500,
            boxShadow: ACTIVE_BOX_SHADOW,
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
            e.currentTarget.style.backgroundColor = Colors.secondary_350;
            e.currentTarget.style.boxShadow = HOVER_BOX_SHADOW;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.backgroundColor = Colors.secondary_500;
            e.currentTarget.style.boxShadow = ACTIVE_BOX_SHADOW;
          }}
        >
          <Icon name="chevron-right" color="#FFFFFF" />
        </button>
      )}
    </Row>
  );
};
